import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import JiraIntegrationLinkQuery, {
	type JiraIntegrationLinkQuery as JiraIntegrationLinkQueryType,
} from '../components/ProjectSidebar/WorkTrackingLinks/JiraIntegrationLink/__generated__/JiraIntegrationLinkQuery.graphql';

export const jiraIntegrationLinkResource: RouteResource<
	PreloadedQuery<JiraIntegrationLinkQueryType, Record<string, unknown>>
> = createRelayResource<JiraIntegrationLinkQueryType>({
	getQuery: (routerContext) => {
		return {
			query: JiraIntegrationLinkQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
			},
		};
	},
});
